import SuperFetchV2 from '../../../superFetchV2';
import queryString from 'query-string';
import {
  AdminExcelDownloadAcceptedResponseType,
  ReviewFindResponseBodyDto,
  ReviewPointReturnedResponseBodyDto,
} from '../../../../types/api/reviews';
import { ReviewFindOneResponseBodyDto } from '../../../../views/cs/review/common/types/ReviewDetailTypes';
import { ReviewPointRetrievedRequestPayload } from '../../../../types/point';
import { ReviewUpdateRequestPayloadType } from '../../../../views/cs/review/common/hook/queries/useUpdateReviewQuery';
import { ReviewCreateRequestType } from '../../../../views/cs/review/common/types/ReviewCreateRequestType';
import { ReviewCreateResponseType } from '../../../../views/cs/review/common/types/ReviewCreateResponseType';
import {
  ReviewListRequestType,
  ReviewsExcelSheetRequestType,
} from '../../../../views/cs/review/common/types/ReviewListType';

class ReviewApiV2 {
  /**
   * [상품 후기 등록] 상품 후기 등록하기
   */
  createReview = (data: ReviewCreateRequestType): Promise<ReviewCreateResponseType> =>
    SuperFetchV2.post('/reviews', data);
  /**
   * [리뷰] 리뷰 상세 정보 조회
   */
  getCsReviewDetail = (id: number): Promise<ReviewFindOneResponseBodyDto> => SuperFetchV2.get(`/reviews/${id}`);
  /**
   * [리뷰] 리뷰 포인트 회수
   */
  retrieveReviewPoint = (payload: ReviewPointRetrievedRequestPayload): Promise<ReviewPointReturnedResponseBodyDto> => {
    const { id, data } = payload;
    return SuperFetchV2.post(`/reviews/${id}/point-returned`, data);
  };
  /**
   * [리뷰] 리뷰 포인트 회수
   */
  updateReviewDetails = (payload: ReviewUpdateRequestPayloadType) => {
    const { id, data } = payload;
    return SuperFetchV2.put(`/reviews/${id}`, data);
  };
  /**
   * [리뷰] 후기 목록 조회
   */
  fetchReviewList = (params: ReviewListRequestType): Promise<ReviewFindResponseBodyDto> => {
    const queryParams = queryString.stringify({ ...params }, { skipNull: true, skipEmptyString: true });
    return SuperFetchV2.get(`/reviews?${queryParams}`);
  };
  /**
   * [리뷰] 후기 목록 엑셀 다운로드 요청
   */
  downloadReviewExcelSheet = (
    params: ReviewsExcelSheetRequestType,
  ): Promise<AdminExcelDownloadAcceptedResponseType> => {
    const queryParams = queryString.stringify({ ...params }, { skipNull: true, skipEmptyString: true });
    return SuperFetchV2.get(`/files/excel-download/reviews?${queryParams}`);
  };
}

export default new ReviewApiV2();
